module.exports = __webpack_public_path__ + "media/images/icons/country_flags/dj-da9d5bb3f5a142e2993b4bf025247990.svg";